import axios from "axios"
const siteUrl = "https://m2elearning.com/e_learning_api-v2/api"

const noAuthConfig = axios.create({
    baseURL: siteUrl,
    headers: {
        'Content-Type': 'application/json',
      }
})

export {noAuthConfig}

